import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {ApplicationModalStep} from "../../application/types/ApplicationModalStep";
import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/form/application_form_source";
import ResponsiveCard from "../../atoms/responsive_card/ResponsiveCard";
import {useResponsiveLinkTarget} from "../../hooks/useResponsiveLinkTarget";
import {IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {getPromotionTypeName} from "../helpers/PromotionType";
import {IPromotionListPromotion} from "../interfaces/IPromotionListResponse";
import {usePromotionStyle} from "./Promotion";

interface IPromotionBox {
    promotion: IPromotionListPromotion;
}

export const PromotionBox = (props: IPromotionBox) => {
    const {promotion} = props;
    const promotionStyle = usePromotionStyle(props.promotion.type);
    const target = useResponsiveLinkTarget();

    const gtmData: IGTMEventLeadForm = {
        clickText: "promotion_box",
        source: GTMEventApplicationSourceSection.PROMOTION,
        vendorName: promotion.offer.vendor.name,
        offerName: promotion.offer.name
    };

    const renderBoxContent = () => {
        return (
            <ResponsiveCard
                cover={
                    <div>
                        <Image
                            src={promotion.offer.main_image.m_img_375x211}
                            alt={promotion.offer.name}
                            width="auto"
                            height="auto"
                            imageClassName={promotionBoxImageHolder}
                        />
                        <Text as="h3" className={css({display: "flex", flexDirection: "column"})}>
                            <Text variant="headline_6" as="span" className={css({pt: 2})}>
                                {promotion.offer.name}{" "}
                            </Text>
                            <Text variant="info_txt_1" as="span" className={css({pt: 2})}>
                                {promotion.offer.address}
                            </Text>
                        </Text>
                    </div>
                }
                coverWidthOnDesktop="336px"
                withCoverPadding
                coverDesktopPosition="left"
                badges={
                    <>
                        <Text as="h2" className={css({display: "flex", flexDirection: "column"})}>
                            <Text variant="mini_header" as="span" className={promotionTypeNameStyle} style={{backgroundColor: promotionStyle.color}}>
                                {getPromotionTypeName(promotion.type)}{" "}
                            </Text>

                            <Text variant="headline_4" as="span">
                                {promotion.name}
                            </Text>
                        </Text>
                    </>
                }
            >
                <ResponsiveCard.Body text={<span className={responsiveCardBody}>{promotion.description}</span>}>
                    <ApplicationModalButton
                        flowVariant="promotion"
                        initialStep={ApplicationModalStep.PROMOTION_FORM}
                        source={ApplicationSource.Promotion}
                        sourceSection={ApplicationSourceSection.MODAL}
                        vendorId={promotion.offer.vendor.id}
                        offerId={promotion.offer.id}
                        propertyId={null}
                        render={({openModal}) => (
                            <Button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openModal(gtmData);
                                }}
                                target={target}
                                size="medium"
                                type="button"
                                variant="filled_primary"
                            >
                                ZAPYTAJ O PROMOCJĘ
                            </Button>
                        )}
                    />
                </ResponsiveCard.Body>
            </ResponsiveCard>
        );
    };

    return (
        <ApplicationModalButton
            flowVariant="promotion"
            initialStep={ApplicationModalStep.PROMOTION_FORM}
            source={ApplicationSource.Promotion}
            sourceSection={ApplicationSourceSection.MODAL}
            vendorId={promotion.offer.vendor.id}
            offerId={promotion.offer.id}
            propertyId={null}
            render={({openModal}) => (
                <li className={promotionBoxHolder} onClick={() => openModal(gtmData)}>
                    {renderBoxContent()}
                </li>
            )}
        />
    );
};

const promotionBoxHolder = css({
    display: "block",
    cursor: "pointer",
    mb: 3
});

const promotionBoxImageHolder = css({
    height: "auto",
    width: "100%",

    sm: {
        maxWidth: "336px"
    },

    md: {
        width: "336px"
    }
});

const promotionTypeNameStyle = css({
    textTransform: "uppercase",
    display: "inline-block",
    width: "fit-content",
    order: 0,
    mb: 2
});

const responsiveCardBody = css({
    display: "none",
    md: {
        display: "inline"
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {ApplicationModalStep} from "../../application/types/ApplicationModalStep";
import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/form/application_form_source";
import ResponsiveCard from "../../atoms/responsive_card/ResponsiveCard";
import {useResponsiveLinkTarget} from "../../hooks/useResponsiveLinkTarget";
import {IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {getPromotionTypeName} from "../helpers/PromotionType";
import {IPromotionListPromotion} from "../interfaces/IPromotionListResponse";
import {usePromotionStyle} from "./Promotion";

interface IPromotionBox {
    promotion: IPromotionListPromotion;
}

export const PromotionBox = (props: IPromotionBox) => {
    const {promotion} = props;
    const promotionStyle = usePromotionStyle(props.promotion.type);
    const target = useResponsiveLinkTarget();

    const gtmData: IGTMEventLeadForm = {
        clickText: "promotion_box",
        source: GTMEventApplicationSourceSection.PROMOTION,
        vendorName: promotion.offer.vendor.name,
        offerName: promotion.offer.name
    };

    const renderBoxContent = () => {
        return (
            <ResponsiveCard
                cover={
                    <div>
                        <Image
                            src={promotion.offer.main_image.m_img_375x211}
                            alt={promotion.offer.name}
                            width="auto"
                            height="auto"
                            imageClassName={promotionBoxImageHolder}
                        />
                        <Text as="h3" className={css({display: "flex", flexDirection: "column"})}>
                            <Text variant="headline_6" as="span" className={css({pt: 2})}>
                                {promotion.offer.name}{" "}
                            </Text>
                            <Text variant="info_txt_1" as="span" className={css({pt: 2})}>
                                {promotion.offer.address}
                            </Text>
                        </Text>
                    </div>
                }
                coverWidthOnDesktop="336px"
                withCoverPadding
                coverDesktopPosition="left"
                badges={
                    <>
                        <Text as="h2" className={css({display: "flex", flexDirection: "column"})}>
                            <Text variant="mini_header" as="span" className={promotionTypeNameStyle} style={{backgroundColor: promotionStyle.color}}>
                                {getPromotionTypeName(promotion.type)}{" "}
                            </Text>

                            <Text variant="headline_4" as="span">
                                {promotion.name}
                            </Text>
                        </Text>
                    </>
                }
            >
                <ResponsiveCard.Body text={<span className={responsiveCardBody}>{promotion.description}</span>}>
                    <ApplicationModalButton
                        flowVariant="promotion"
                        initialStep={ApplicationModalStep.PROMOTION_FORM}
                        source={ApplicationSource.Promotion}
                        sourceSection={ApplicationSourceSection.MODAL}
                        vendorId={promotion.offer.vendor.id}
                        offerId={promotion.offer.id}
                        propertyId={null}
                        render={({openModal}) => (
                            <Button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openModal(gtmData);
                                }}
                                target={target}
                                size="medium"
                                type="button"
                                variant="filled_primary"
                            >
                                ZAPYTAJ O PROMOCJĘ
                            </Button>
                        )}
                    />
                </ResponsiveCard.Body>
            </ResponsiveCard>
        );
    };

    return (
        <ApplicationModalButton
            flowVariant="promotion"
            initialStep={ApplicationModalStep.PROMOTION_FORM}
            source={ApplicationSource.Promotion}
            sourceSection={ApplicationSourceSection.MODAL}
            vendorId={promotion.offer.vendor.id}
            offerId={promotion.offer.id}
            propertyId={null}
            render={({openModal}) => (
                <li className={promotionBoxHolder} onClick={() => openModal(gtmData)}>
                    {renderBoxContent()}
                </li>
            )}
        />
    );
};

const promotionBoxHolder = css({
    display: "block",
    cursor: "pointer",
    mb: 3
});

const promotionBoxImageHolder = css({
    height: "auto",
    width: "100%",

    sm: {
        maxWidth: "336px"
    },

    md: {
        width: "336px"
    }
});

const promotionTypeNameStyle = css({
    textTransform: "uppercase",
    display: "inline-block",
    width: "fit-content",
    order: 0,
    mb: 2
});

const responsiveCardBody = css({
    display: "none",
    md: {
        display: "inline"
    }
});
